import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme: MuiTheme) => {
  const {
    primary: { light, dark }
  } = theme.palette;

  return {
    root: {
      height: 60,
      padding: "8px 24px",
      borderBottom: `1px solid ${light}`,
      display: "flex",
      justifyContent: "space-between",
      backgroundColor: "#fff"
    },
    leftSide: {
      minWidth: 280
    },
    bold: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 16
    },
    deadline: {
      color: dark
    },
    rightSide: {
      display: "flex",
      alignItems: "center"
    },
    trainerName: {
      textAlign: "end",
      wordBreak: "break-all",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical"
    },
    contactButton: {
      display: "none",
      width: 98,
      height: 32,
      padding: 0,
      marginLeft: 25,
      fontSize: 12,
      color: dark,
      textTransform: "capitalize",
      border: `1px solid ${light}`,
      borderRadius: 3
    }
  };
});
